import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';

import {
  ListItemText,
  Avatar,
  ListItemAvatar,
  ListItem,
  List,
  MenuItem,
  Select,
  FormControl,
  Grid,
  Typography,
  Divider,
  Button,
  InputLabel,
} from '@mui/material';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { getPractionersDetailsAction } from '../../Redux/Actions/userAction';
import HelmetReact from '../../Components/Helmet';
import LineChart from '../../Components/Chart';

import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
  getPractitionerDetailChart,
  getProgramChartData,
} from '../../Redux/Actions/OverviewAction';
import { saveAs } from 'file-saver';
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  pdf,
} from '@react-pdf/renderer';

const ViewMyPatientDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { practionerDetails } = useSelector((state) => state.User);
  const [download, setDownload] = useState('Download')
  const { OverviewList, PractitionerOverview } = useSelector(
    (state) => state.Overview
  );
  const [totalMonth, setTotalMonth] = useState(6);
  const handleChange = (e) => {
    let payload = {
      Id: id,
      Month:  e.target.value
    ,
    };
    setTotalMonth(e.target.value);
    dispatch(getPractitionerDetailChart(payload));
  };

  useEffect(() => {
    let payload =  {
      Id:  id,
      Month:  6,
    };
    dispatch(getPractitionerDetailChart(payload));
  }, [dispatch]);
  useEffect(() => {
    dispatch(getPractionersDetailsAction(id));
  }, []);

  const goBack = () => {
    navigate('/users', { state: 'PRACTIONERS' });
  };
  const labels2 =
    OverviewList?.active_user_doctor?.length &&
    OverviewList?.active_user_doctor?.map((value) => value.month);
  const data2 = {
    labels: labels2,
    datasets: [
      {
        label: 'Clients',
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value.patient),
        fill: true,
        backgroundColor: 'rgba(155,230,249,0.5)',
        borderColor: 'rgb(155,230,249)',
        pointBackgroundColor: 'white',
        pointStyle: 'circle',
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
      {
        label: 'Practioners',
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value.doctor),
        fill: true,
        backgroundColor: 'rgba(198,151,245,0.5)',
        borderColor: 'rgb(198, 151, 245)',
        pointBackgroundColor: 'white',
        pointStyle: 'circle',
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };
  const options3 = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'start',
        onClick: null,
      },
      title: {
        display: true,
      },
      interaction: {
        intersect: true,
      },
      tooltip: {
        usePointStyle: false,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: 'x',
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: 'x',
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          callback: function (tick) {
            var characterLimit = 4;

            if (labels2.length > 4) {
              if (labels2[tick]?.length >= characterLimit) {
                return (
                  labels2[tick]
                    .slice(0, labels2[tick]?.length)
                    .substring(0, characterLimit - 1)
                    .trim() + '..'
                );
              }
            }
            return labels2[tick];
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
      },
    },
  };

  const labels =
    PractitionerOverview?.programList?.length &&
    PractitionerOverview?.programList?.map((value) => value.program);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Program',
        data:
          PractitionerOverview?.programList?.length &&
          PractitionerOverview?.programList?.map((value) =>
            Math.ceil(value.value)
          ),
        fill: true,
        backgroundColor: 'rgba(155,230,249,0.5)',
        borderColor: 'rgb(155,230,249)',
        pointBackgroundColor: 'white',
        pointStyle: 'circle',
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };
  const options = {
    type: 'line',
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'start',
        onClick: null,
      },
      title: {
        display: true,
      },
      interaction: {
        intersect: true,
      },
      tooltip: {
        usePointStyle: false,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: 'x',
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: 'x',
        },
      },
    },
    scales: {
      x: {
        ticks: {
          callback: function (tick) {
            var characterLimit = 6;

            if (labels[tick]?.length >= characterLimit) {
              return (
                labels[tick]
                  .slice(0, labels[tick]?.length)
                  .substring(0, characterLimit - 1)
                  .trim() + '..'
              );
            }

            return labels[tick];
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            return value + ' %';
          },
        },
      },
    },
  };

  const styles = StyleSheet.create({
    mainPage: {
      padding: '10px',
      fontSize: '12px',
      backgroundColor: '#f9f9f9',
      color: 'grey',
    },

    scoreMainCard: {
      marginLeft: '30px',
      width: '25vw',
    },
    scoreLabel: {
      margin: '20px 0px auto 0px',
      fontSize: '15px',
    },

    scoreSubLabel1: { margin: '10px 0px 0px 50px', display: 'flex' },
    scoreSubLabel2: { margin: '10px 0px 0px 120px', fontWeight: '800' },
    scoreCardSubLabel1: {
      fontSize: '15px',
      marginLeft: '30px',
    },
    scoreCardSubLabel2: {
      textAlign: 'center',
      width: '50px',
      backgroundColor: '#1976d2',
      color: 'white',
    },
    divider: {
      borderBottom: '1px solid black',
      width: '25vw',
      marginTop: '10px',
    },
    DataContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '20px 0px',
    },
    DataContainer1: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '0px 0px',
    },
    DataContainerLabel: {
      flexDirection: 'row',
    },
    ImageBox: {
      width: '400px',
      border: '1px solid black',
      borderRadius: '5px',
      padding: '5px',
      margin: '3px',
    },
    AlignLabel1: {
      position: 'relative',
      top: '-350px',
      left: '665px',
    },
    AlignLabel2: {
      position: 'relative',
      top: '-370px',
      left: '665px',
    },
    AlignLabel3: {
      position: 'relative',
      top: '-390px',
      left: '665px',
    },
    AlignLabel4: {
      position: 'relative',
      top: '-410px',
      left: '665px',
    },
    AlignLabel5: {
      fontSize: '11px',
      marginLeft: '10px',
    },
    AlignLabel6: {
      fontSize: '11px',
      marginLeft: '150px',
    },

  });

  let data1 = [];
  const data3 = {
    labels: labels2,
    datasets: [
      {
        label: 'LOAD TIMES',
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value.patient),
        fill: true,
        backgroundColor: 'rgba(155,230,249,0.5)',
        borderColor: 'rgb(155,230,249)',
        pointBackgroundColor: 'white',
        pointStyle: 'circle',
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
      {
        label: 'CRASH  RATE',
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value.doctor),
        fill: true,
        backgroundColor: 'rgba(230,201,98,0.39)',
        borderColor: 'rgb(232,189,36)',
        pointBackgroundColor: 'white',
        pointStyle: 'circle',
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
      {
        label: 'ERROR  RATE',
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value.doctor),
        fill: true,
        backgroundColor: 'rgba(198,151,245,0.5)',
        borderColor: 'rgb(198, 151, 245)',
        pointBackgroundColor: 'white',
        pointStyle: 'circle',
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };
  PractitionerOverview?.programList?.length &&
    PractitionerOverview?.programList?.map((item, index) => {
      data1.push({
        Program: item.program,
        CompletionRate: item.value,
      });
    });

  const formatDataToCSV = (data) => {
    const header = Object.keys(data[0]).join(',');
    const rows = data.map((item) => Object.values(item).join(','));
    return `${header}\n${rows.join('\n')}`;
  };

  const downloadCSV = (csvData) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = 'Practitioner Report.csv';
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCSV = async () => {
    if (data1?.length) {
      const csvData = formatDataToCSV(data1);
      downloadCSV(csvData);
    }
    else 
    alert("No Data Found For CSV")
  };

  const generatePDF = async () => {
    const chartCanvas1 = await document.querySelector('#chart1');
    // const chartCanvas2 = await document.querySelector('#chart3');
    // const chartCanvas3 = await document.querySelector('#chart4');
    const chartData1 = await chartCanvas1.toDataURL();
    // const chartData2 = await chartCanvas2.toDataURL();
    // const chartData3 = await chartCanvas3.toDataURL();

    const blob = await pdf(
      <Document>
        <Page style={styles.mainPage} wrap size="A4" orientation="landscape">
          <View>
            <View style={styles.DataContainer}>
              <Image src={chartData1} />
            </View>
            <View style={styles.DataContainerLabel}>
              <Text style={styles.AlignLabel5}>
                Program Completion Rate (%)
              </Text>
            </View>
            {/* <View style={styles.DataContainer1}>
              <Image src={chartData2} /> <Image src={chartData3} />
            </View>
            <View style={styles.DataContainerLabel}>
              <Text style={styles.AlignLabel5}>
                APP PERFOMANCE: APP LOAD TIMES, CRASH RATES, AND ERROR RATES
              </Text>
              <Text style={styles.AlignLabel6}>
                REVENUE($): TOTAL AND CATEGORISED BY SUBSCRIPTION PLAN
              </Text>
            </View> */}
          </View>
        </Page>
      </Document>
    ).toBlob();
    saveAs(blob, 'Practitioners Report');
  };

  const handleChangeDownload = (e) => {
    setDownload(e.target.value)
    e.target.value === "csv" ? handleDownloadCSV()
      : generatePDF()
  }
  return (
    <>
      <HelmetReact name="User" />
      <Box className="d-details-box">
        <Box className="dDetails-img">
          <Typography className="web-title">PRACTIONER DATA</Typography>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <button onClick={() => goBack()} className="back-btn">
                <ArrowBackIosIcon
                  size="large"
                  edge="start"
                  aria-label="menu"
                  sx={{ mr: 2, color: 'grey', flexGrow: 0, cursor: 'pointer' }}
                />
              </button>
            </Grid>

            {/* <Grid item lg={6} md={6} sm={6} xs={12}>
           
              <FormControl sx={{ float: "right" }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  autoWidth
                  defaultValue="Download"
                  onChange={handleChangeDownload}
                  sx={{ backgroundColor: "white" }}
                >
                  <MenuItem disabled value={"Download"}>Download</MenuItem>
                  <MenuItem value={"pdf"}>PDF</MenuItem>
                  <MenuItem value={"csv"}>CSV</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
          </Grid>
          <Grid container spacing={2} sx={{ my: 1 }}>
            <Grid item lg={12} md={6} xs={12}>
              <Box sx={{
                // my: 2,
                display: "flex",
                justifyContent: "end",
                gap: "5px"
              }}>

                <FormControl >
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    autoWidth
                    defaultValue="Download"
                    onChange={handleChangeDownload}
                    sx={{ backgroundColor: "white" }}
                  >
                    <MenuItem disabled value={"Download"}>Download</MenuItem>
                    <MenuItem value={"pdf"}>PDF</MenuItem>
                    <MenuItem value={"csv"}>CSV</MenuItem>
                  </Select>
                </FormControl>

                <FormControl>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    autoWidth
                    defaultValue={6}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: 'white',
                    }}
                  >
                    <MenuItem value={3}>Last 3 Months</MenuItem>
                    <MenuItem value={6}>Last 6 Months</MenuItem>
                    <MenuItem value={12}>1 Year</MenuItem>
                  </Select>
                </FormControl>


              </Box>
              <LineChart
                data={data}
                options={options}
                id="chart1"
                className="chart-item"
                type="line"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: 'grey', my: 3 }}
              >
                Program Completion Rate (%)
              </Typography>
            </Grid>
          </Grid>
        </Box>
        {/* <Box className="dDetails-img">
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                data={data3}
                id="chart3"
                options={options3}
                className="chart-item"
                type="bar"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: 'grey', my: 3 }}
              >
                APP PERFOMANCE: APP LOAD TIMES, CRASH RATES, AND ERROR RATES
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                data={data3}
                id="chart4"
                options={options3}
                className="chart-item"
                type="bar"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: 'grey', my: 3 }}
              >
                REVENUE($): TOTAL AND CATEGORISED BY SUBSCRIPTION PLAN
              </Typography>
            </Grid>
          </Grid>
        </Box> */}
      </Box>
    </>
  );
};

export default ViewMyPatientDetails;
